type SortOrder = Record<string, number>;

export const sortByPropertyValue = <T>(items: T[], key: keyof T, sortOrder: SortOrder): T[] =>
  items.sort((a, b) => {
    const aValue = a[key] as unknown as string;
    const bValue = b[key] as unknown as string;

    return (sortOrder[aValue] ?? 0) - (sortOrder[bValue] ?? 0);
  });
